// extracted by mini-css-extract-plugin
export default {"trigger":"_9ehkA","skeleton-progress":"SnNLd"};